"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HealthcareDesignedForYou() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="healthcare-designed-for-you" className="relative overflow-hidden bg-background py-24 lg:py-32">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid items-center gap-16 lg:grid-cols-[6fr_4fr] lg:gap-12">
          
          {}
          <div ref={textRef} className={`flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <h1 className="font-serif text-5xl leading-[1.1] tracking-tight !text-[hsl(223,23%,43%)] md:text-6xl lg:text-7xl">Unlimited access to your doctor. No insurance. One simple monthly fee.</h1>
            
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-muted-foreground md:text-xl">Experience comprehensive primary care through a direct primary care (DPC) model in Trophy Club, TX, serving families in DFW. Built on a patient-centered approach. We offer same-day or next-day appointments, personalized health plans, and unlimited office visits for a modest monthly fee. By operating outside traditional insurance networks, we provide transparent pricing and the longer consultation times you deserve without feeling rushed or unheard to improve patient health outcome.</p>
            
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Button size="lg" className="h-12 rounded-full px-8 text-base" asChild>
                <Link to="/MembershipPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground shadow-xs has-[>svg]:px-4 h-12 rounded-full px-8 text-base !bg-[hsl(222,23%,43%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90">Start Membership</Link>
              </Button>
              <Button variant="ghost" size="lg" className="h-12 rounded-full px-6 text-base" asChild>
                <Link to="/AboutPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 h-12 rounded-full px-6 text-base group flex items-center gap-2 !text-[hsl(223,23%,43%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50">
                  How it Works
                  <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative mx-auto w-full max-w-md lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            {}
            <div className="absolute -inset-4 z-0 rounded-tl-[12rem] rounded-br-[12rem] rounded-tr-3xl rounded-bl-3xl bg-primary/5 blur-2xl transition-transform duration-1000 hover:scale-105" />
            
            <div className="relative z-10 aspect-[4/5] w-full overflow-hidden rounded-tl-[12rem] rounded-br-[12rem] rounded-tr-2xl rounded-bl-2xl border border-border/50 bg-muted shadow-2xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615506/img/physician_patient_sunlit_office.png" alt="Physician and patient in a warm, sunlit office consultation" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              
              {}
              <div className="absolute inset-0 rounded-tl-[12rem] rounded-br-[12rem] rounded-tr-2xl rounded-bl-2xl ring-1 ring-inset ring-foreground/10" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}